export const ACTIVE_MENU_ITEM_COLOR = "#005344";
